import { useDateFormat } from 'react-common'
import { LearnerObjectiveAccessCompactModel, ObjectiveWorkflowState } from '@/api/models/aggregate'

const FORMAT_OPTIONS: Intl.DateTimeFormatOptions = { month: 'short' }

export const usePrepareCourseInfo = (objectiveWorkflowAggregate: LearnerObjectiveAccessCompactModel) => {
  const { formatDate } = useDateFormat()

  const finishedDate = formatDate(
    objectiveWorkflowAggregate?.objectiveWorkflowAggregate?.lastObjectiveRecord?.finished,
    FORMAT_OPTIONS,
  )
  const startedDate = formatDate(
    objectiveWorkflowAggregate?.objectiveWorkflowAggregate?.lastObjectiveWorkflow?.started,
    FORMAT_OPTIONS,
  )
  const submittedDate = formatDate(
    objectiveWorkflowAggregate?.objectiveWorkflowAggregate?.lastObjectiveWorkflow?.submitted,
    FORMAT_OPTIONS,
  )
  const dueDate = formatDate(objectiveWorkflowAggregate?.dueDate!, FORMAT_OPTIONS)
  const availabilityDate = formatDate(objectiveWorkflowAggregate?.availabilityDate!, FORMAT_OPTIONS)

  const isNotStarted =
    !objectiveWorkflowAggregate?.objectiveWorkflowAggregate?.lastObjectiveWorkflow &&
    !objectiveWorkflowAggregate?.objectiveWorkflowAggregate?.lastObjectiveRecord

  const isFinished = (() => {
    const lastObjectiveWorkflow = objectiveWorkflowAggregate?.objectiveWorkflowAggregate?.lastObjectiveWorkflow
    const lastObjectiveRecord = objectiveWorkflowAggregate?.objectiveWorkflowAggregate?.lastObjectiveRecord

    return lastObjectiveWorkflow
      ? lastObjectiveWorkflow.state === ObjectiveWorkflowState.finished
      : Boolean(lastObjectiveRecord?.finished)
  })()

  const isInProgress =
    objectiveWorkflowAggregate?.objectiveWorkflowAggregate?.lastObjectiveWorkflow?.state ===
    ObjectiveWorkflowState.inProgress

  return {
    finishedDate,
    submittedDate,
    startedDate,
    dueDate,
    availabilityDate,
    isNotStarted,
    isFinished,
    isInProgress,
  }
}
